module.exports = "/images/icon_close_black.svg?521bd1f1e5b9a1332ca6b0ec4b516460";